/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";
export const MOVE_TO_SHELF = gql`
  mutation MoveBoxesToShelf($boxes: [String], $shelf: String) {
    moveBoxesToShelf(boxes: $boxes, shelf: $shelf) {
      activeStatus
      band {
        label
        name
      }
      boxesCount
    }
  }
`;
